export default __webpack_public_path__ + "static/media/aramex.13b07c69.svg";